module.exports = __webpack_public_path__ + "static/img/logo-shopvidi-new.820990d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-shopvidi-new.png
// module id = ZSnR
// module chunks = 2